import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getEntityTriggerTypeList() {
  return request({
    url: URL.sys.entityTriggerType,
    method: 'get'
  })
}
// 获取平台和租户的触发类型列表
export function queryPlatformAndTenantList() {
  return request({
    url: URL.sys.queryPlatformAndTenantList,
    method: 'get'
  })
}

export function addEntityTriggerType(data) {
  return request({
    url: URL.sys.entityTriggerType,
    method: 'post',
    data
  })
}

export function updateEntityTriggerType(data) {
  return request({
    url: URL.sys.entityTriggerType,
    method: 'put',
    data
  })
}

export function delEntityTriggerType(uuid) {
  const params = { uuid }
  return request({
    url: URL.sys.entityTriggerType,
    method: 'delete',
    params
  })
}
// 获取租户使用过的触发类型列表及平台触发类型列表
export function queryTenantUseEntityTriggerType() {
  return request({
    url: URL.sys.queryTenantUseEntityTriggerType,
    method: 'get'
  })
}
